export const PASSWORD_CAPTION =
  'Password must contain at least 1 uppercase letter, 1 lowercase letter, 1 number, and be a minimum of 8 characters';
